import { j as a } from "../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.mjs";
const t = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }) })
  ],
  [
    "duotone",
    /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }),
      /* @__PURE__ */ a.jsx("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" })
    ] })
  ],
  [
    "fill",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }) })
  ],
  [
    "light",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }) })
  ],
  [
    "regular",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }) })
  ],
  [
    "thin",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }) })
  ]
]);
export {
  t as default
};
